/**
 * OnCallWidget — shows who is currently on call.
 */

import { useEffect, useState } from "react";
import { apiFetch } from "../../../lib/config";

interface OnCallMember {
  id: string;
  name: string;
  email: string;
}

interface Props {
  config: Record<string, unknown>;
}

export function OnCallWidget({ config: _config }: Props) {
  const [member, setMember] = useState<OnCallMember | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    apiFetch("/api/v1/oncall/current/")
      .then((r) => r.json())
      .then((d) => setMember(d.member ?? null))
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="aptean-widget-skeleton" style={{ height: 40 }} />;
  if (error) return <p style={{ color: "var(--aptean-error, #e74c3c)", margin: 0 }}>Error: {error}</p>;

  return (
    <p style={{ margin: 0, color: "var(--aptean-text-primary)" }}>
      {member ? (
        <>
          On call now:{" "}
          <strong>{member.name}</strong>{" "}
          <span style={{ color: "var(--aptean-text-secondary)", fontSize: "0.85rem" }}>
            ({member.email})
          </span>
        </>
      ) : (
        <span style={{ color: "var(--aptean-text-secondary)" }}>No one on call</span>
      )}
    </p>
  );
}
